<template>
  <div class="newhome">
    <ul class="n-navMenu">
      <li class="navOne" v-for="(item, index) in navMenuList" :key="index" @click.stop="navClick(item)">
        {{ item.text }}
        <ul v-show="item.childs">
          <li class="navTwo" v-for="(citem, cindex) in item.childs" :key="cindex" @click.stop="navClick(citem)">
            {{ citem.text }}
          </li>
        </ul>
      </li>
    </ul>
    <div class="ggImg">
      <img :src="backgroundImg" alt="">
    </div>
    <div class="special">
      <div class="special-left">
        特别推荐
      </div>
      <div class="special-right">
        <div class="swiper-inner">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in list" :key="index">
              <div class="swiper-content" @click="goUrl(item.url)">
                <img :src="item.imgUrl" class="image">
                <p class="p1">{{ item.name }}</p>
                <p class="p2">{{ item.content }}</p>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <div class="Journalism-view">
      <div class="list-view">
        <p class="header-title">
          党政新闻
          <a class="gd" href="http://www.zgzcinfo.cn/policyrelease.html" target="_blank">+更多</a>
        </p>
        <ul>
          <li v-for="(item, index) in list1" :key="index" @click="goUrl(item.url)">
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div class="list-view">
        <p class="header-title">
          政策解读
          <a class="gd" href="http://www.zgzcinfo.cn/auditorium.html" target="_blank">+更多</a>
        </p>
        <ul>
          <li v-for="(item, index) in list2" :key="index" @click="goUrl(item.url)">
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div class="list-view">
        <p class="header-title">
          数据库
          <a class="gd" href="http://www.zgzcinfo.cn/search.html" target="_blank">+更多</a>
        </p>
        <table>
          <tbody>
            <tr>
              <td style="background: #83b92e">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1273.html" target="_blank">历届三中全会</a>
              </td>
              <td style="background: #191d41">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1272.html" target="_blank">中央1号文件</a>
              </td>
              <td style="background: #0068ab" colspan="2">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1269.html" target="_blank">自由贸易区建设</a>
              </td>
            </tr>
            <tr>
              <td style="background: #38afb6;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1267.html" target="_blank">雄安新区建设</a>
              </td>
              <td style="background: #eabf2a" colspan="2">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1263.html" target="_blank">美丽中国(污染防治)</a>
              </td>
              <td style="background: #56beef;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1266.html" target="_blank">长江经济带建设</a>
              </td>
            </tr>
            <tr>
              <td style="background: #e44c28;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1258.html" target="_blank">高质量发展</a>
              </td>
              <td style="background: #444d5c">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1373.html" target="_blank">健康中国</a>
              </td>
              <td style="background: #83b92e;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1420.html" target="_blank">新发展理念</a>
              </td>
              <td style="background: #191d41;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1262.html" target="_blank">精准脱贫</a>
              </td>
            </tr>
            <tr>
              <td style="background: #0068ab;" colspan="2">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1374.html" target="_blank">中央经济工作会议</a>
              </td>
              <td style="background: #38afb6">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1254.html" target="_blank">放管服改革</a>
              </td>
              <td style="background: #eabf2a;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1268.html" target="_blank">一代一路建设</a>
              </td>
            </tr>
            <tr>
              <td style="background: #56beef;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1265.html" target="_blank">现代化经济体系</a>
              </td>
              <td style="background: #e44c28" colspan="2">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1264.html" target="_blank">防范化解重大风险</a>
              </td>
              <td style="background: #444d5c;">
                <a href="http://www.zgzcinfo.cn/specialtopic/list-1375.html" target="_blank">大国经济政策</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      list1: [],
      list2: [],
      backgroundImg: '',
      // require('@/assets/111.jpg')
      list: [],
      swiperOption: {
        effect: 'slide',
        grabCursor: true,
        // centeredSlides: true,
        // slidesPerView: 'auto',
        slidesPerView: 3,
        // coverflowEffect: {
        //   rotate: 50,
        //   stretch: 0,
        //   depth: 50,
        //   modifier: 1
        // },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      ggImgUrl: require('@/assets/111.jpg'),
      navMenuList: [{
        text: '首页',
        url: 'http://www.zgzcinfo.cn/index.html'
      }, {
        text: '党政新闻',
        url: 'http://www.zgzcinfo.cn/policyrelease.html',
        childs: [{
          text: '最新消息',
          url: 'http://www.zgzcinfo.cn/policyrelease.html'
        }, {
          text: '中央政情',
          url: 'http://www.zgzcinfo.cn/policyrelease.html'
        }, {
          text: '地方动态',
          url: 'http://www.zgzcinfo.cn/policyrelease.html'
        }, {
          text: '国际信息',
          url: 'http://www.zgzcinfo.cn/policyrelease.html'
        }]
      }, {
        text: '党政视频',
        url: 'http://www.zgzcinfo.cn/auditorium.html'
        // childs: [{
        //   text: '党的建设',
        //   url: ''
        // }, {
        //   text: '政策解读科学人文',
        //   url: ''
        // }]
      }, {
        text: '党政图书',
        url: '',
        childs: [{
          text: '政策类',
          url: '',
          id: 1
        }, {
          text: '社科类',
          url: '',
          id: 2
        }, {
          text: '经管类',
          url: '',
          id: 3
        }, {
          text: '文学类',
          url: '',
          id: 6
        }, {
          text: '教育类',
          url: '',
          id: 7
        }, {
          text: '其他类',
          url: '',
          id: 8
        }]
      }, {
        text: '党政学习',
        url: '',
        childs: [{
          text: '党策解读',
          url: 'http://www.zgzcinfo.cn/policyparsing.html'
        }, {
          text: '大讲堂',
          url: 'http://www.zgzcinfo.cn/auditorium.html'
        }]
      }, {
        text: '数据库',
        url: 'http://www.zgzcinfo.cn/search.html'
      }]
    }
  },
  methods: {
    navClick (item) {
      if (item.url) {
        window.open(item.url)
      } else if (item.id) {
        this.$router.push({
          name: 'Classification',
          params: {
            catId: item.id,
            text: item.text
          }
        })
      }
    },
    goUrl (url) {
      window.open(url)
    },
    get_policy_release_list () {
      this.$post(window.g.ysUrl + 'policy/get_policy_release_list').then(res => {
        if (res.code === '0') {
          let list = res.data
          this.list1 = []
          list.forEach(e => {
            this.list1.push({
              text: e.title,
              url: `http://www.zgzcinfo.cn/policyrelease/show-${e.id}.html`
            })
          })
        }
      })
    },
    get_policy_parsing_list () {
      this.$post(window.g.ysUrl + 'policy/get_policy_parsing_list').then(res => {
        if (res.code === '0') {
          let list = res.data
          this.list2 = []
          list.forEach(e => {
            this.list2.push({
              text: e.title,
              url: `http://www.zgzcinfo.cn/policyparsing/show-${e.id}.html`
            })
          })
        }
      })
    },
    get_recommend_list () {
      this.$post(window.g.ysUrl + 'policy/get_recommend_list').then(res => {
        if (res.code === '0') {
          let list = res.data
          this.list = []
          list.forEach(e => {
            this.list.push({
              url: `http://www.zgzcinfo.cn/index/show-${e.id}.html`,
              imgUrl: 'http://www.zgzcinfo.cn/' + e.imgUrl,
              name: e.title,
              content: e.zhaiyao
            })
          })
        }
      })
    },
    getTopAd () { // 获取图片
      this.$get(`${this.$allUrl.getTopAd}?adCode=WEBSYZST001`).then(res => {
        if (res.code === '0') {
          this.backgroundImg = res.data ? res.data : require('@/assets/111.jpg')
        } else {
          this.backgroundImg = require('@/assets/111.jpg')
        }
      })
    }
  },
  mounted () {
    this.get_policy_release_list()
    this.get_policy_parsing_list()
    this.get_recommend_list()
    this.getTopAd()
  }
}
</script>
<style lang="less" scoped>
  .newhome{
    width: 100%;
    padding-top: 10px;
    ul{
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .n-navMenu{
      display: flex;
      .navOne{
        flex: 1;
        text-align: center;
        height: 40px;
        color: white;
        line-height: 40px;
        background-color: #011753;
        cursor: pointer;
        ul{
          display: none;
        }
      }
      .navOne:hover{
        background-color: #153697;
        position: relative;
        ul{
          z-index: 100;
          display: block;
          position: absolute;
          width: 100%;
          background: yellow;
          top: 40px;
          background: linear-gradient(#153697, #8DA4E8); /* 标准的语法 */
          .navTwo:hover{
            background-color: #011753;
            cursor: pointer;
          }
        }
      }
    }
    .ggImg{
      height: 300px;
      position: absolute;
      width: 100%;
      min-width: 1200px;
      left: 0;
      display: block;
      img{
        height: 100%;
        width: 100%;
        position: relative;
      }
    }
    .special{
      margin-top: 300px;
      background: white;
      display: flex;
      padding: 10px;
      .special-left{
        background-color: #A90013;
        width: 40px;
        word-wrap: break-word;
        letter-spacing:5px;
        text-align: center;
        color: white;
        padding: 50px 0;
      }
      .special-right{
        flex: 1;
        overflow: hidden;
        .swiper-inner {
          .swiper-content{
            padding: 0 10px;
            p{
              padding: 0;
              margin: 0;
              font-size: 12px;
            }
            .p1{
              font-size: 14px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              padding: 5px 0;
              font-weight: 600;
            }
            .p2{
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            img{
              width: 100%;
              height: 150px;
            }
          }
        }
      }
    }
    .Journalism-view{
      display: flex;
      padding-bottom: 20px;
      .list-view{
        flex: 1;
        padding-right: 20px;
        padding-left: 5px;
        overflow: hidden;
        .header-title{
          color: #A90013;
          border-left: 2px solid #A90013;
          text-indent: 5px;
          font-weight: 600;
          margin-bottom: 0;
          .gd{
            float: right;
            color: black;
            font-size: 12px;
            cursor: pointer;
            text-decoration: none;
          }
        }
        ul{
          margin-left: 10px;
          font-size: 14px;
          color: #7C7C7C;
          width: 100%;
          li{
            width: 100%;
            padding: 8px 0;
            border-top: 1px solid #eeeeee;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }
          li:hover{
            color: #A90013;
          }
        }
        table{
          width: 100%;
          table-layout: fixed;
          margin-top: 20px;
          tr{
            width: 100%;
            td{
              text-align: center;
              a{
                color: white;
                text-decoration: none;
                padding: 10px 0;
                display: block;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewHome/newHome.vue